var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    className: "user_svg__icon",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M654.25 597.333c0 28.928 55.04 68.779 165.035 119.723 32.512 8.704 62.976 18.176 91.478 28.416a85.33 85.33 0 0 1 56.32 80.213v56.064a85.333 85.333 0 0 1-85.334 85.334H128A71.083 71.083 0 0 1 56.917 896v-47.19a85.33 85.33 0 0 1 18.603-53.247q46.336-57.984 152.064-84.48l9.643-2.475c88.405-46.933 132.522-83.968 132.522-111.275 0-3.328 0-6.57-.17-9.728A284.416 284.416 0 0 1 512 56.832h227.499c31.402 0 56.832 25.6 56.832 56.917v227.584c0 105.216-57.088 197.12-141.995 246.272a213 213 0 0 0-.085 9.728"
  })));
};
export default SvgUser;